import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const quickAccessItems = [
  {
    id: 1,
    title: "Bible Reader",
    description: "Immerse yourself in scripture with multiple translations and study tools",
    icon: "BookOpenIcon",
    href: "/bible-reader",
    color: "bg-primary",
    stats: "66 Books Available"
  },
  {
    id: 2,
    title: "Audio Library",
    description: "Listen to complete Bible audiobooks and inspiring teachings",
    icon: "SpeakerWaveIcon",
    href: "/audio-book-library",
    color: "bg-secondary",
    stats: "1,200+ Hours"
  },
  {
    id: 3,
    title: "Live Streams",
    description: "Join live Christian TV and radio programming 24/7",
    icon: "VideoCameraIcon",
    href: "/live-streams-hub",
    color: "bg-accent",
    stats: "12 Channels"
  },
  {
    id: 4,
    title: "Digital Library",
    description: "Access eBooks, study guides, and theological resources",
    icon: "AcademicCapIcon",
    href: "/digital-books-library",
    color: "bg-success",
    stats: "500+ Resources"
  },
  {
    id: 5,
    title: "Community Hub",
    description: "Connect with fellow believers in discussion forums",
    icon: "UserGroupIcon",
    href: "/community-hub",
    color: "bg-warning",
    stats: "50K+ Members"
  },
  {
    id: 6,
    title: "Personal Dashboard",
    description: "Track your spiritual journey and manage your content",
    icon: "ChartBarIcon",
    href: "/personal-dashboard",
    color: "bg-primary",
    stats: "Your Progress"
  }
];

export default function QuickAccess() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-crimson font-semibold text-foreground mb-4">
            Explore Sacred Wisdom
          </h2>
          <p className="text-lg text-muted-foreground font-source-serif max-w-2xl mx-auto">
            Access divine wisdom through multiple formats and connect with a community 
            of believers on their spiritual journey.
          </p>
        </div>

        {/* Quick Access Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {quickAccessItems?.map((item) => (
            <Link
              key={item?.id}
              href={item?.href}
              className="group bg-card rounded-2xl p-6 border border-border hover-lift contemplative-transition cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 w-12 h-12 ${item?.color} rounded-xl flex items-center justify-center text-white group-hover:scale-110 contemplative-transition`}>
                  <Icon name={item?.icon} size={24} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="font-inter font-semibold text-foreground mb-2 group-hover:text-primary contemplative-transition">
                    {item?.title}
                  </h3>
                  
                  <p className="text-sm text-muted-foreground font-source-serif mb-3 line-clamp-2">
                    {item?.description}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-primary font-inter font-medium">
                      {item?.stats}
                    </span>
                    
                    <Icon 
                      name="ArrowRightIcon" 
                      size={16} 
                      className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 contemplative-transition" 
                    />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-secondary/10 rounded-2xl p-8">
            <h3 className="text-2xl font-crimson font-semibold text-foreground mb-4">
              Ready to Begin Your Spiritual Journey?
            </h3>
            <p className="text-muted-foreground font-source-serif mb-6 max-w-xl mx-auto">
              Join thousands of women discovering divine wisdom through our comprehensive 
              digital Bible platform designed for modern believers.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                href="/personal-dashboard"
                className="bg-primary text-primary-foreground px-8 py-3 rounded-xl font-inter font-semibold hover-lift contemplative-transition"
              >
                Create Free Account
              </Link>
              <Link 
                href="/community-hub"
                className="text-primary font-inter font-semibold px-8 py-3 rounded-xl border border-primary hover:bg-primary hover:text-primary-foreground contemplative-transition"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}